export default "__VITE_ASSET__Cd54h3Db__"